<script lang="ts" setup>
import { storeToRefs } from 'pinia'
import { useCommerceStore } from '~/stores/pos/commerce'
import ProductItemRenderer from '~/components/PublicStore/Renderers/ProductItem.vue'
import ComboItemRenderer from '~/components/PublicStore/Renderers/ComboItem.vue'
import CustomComboItemRenderer from '~/components/PublicStore/Renderers/CustomComboItem.vue'

interface Props {
  compactView?: boolean
}

const props = withDefaults(defineProps<Props>(), {
  compactView: false,
})

const commerceStore = useCommerceStore()
const { cart } = storeToRefs(commerceStore)
const {
  removeProductFromCart,
  editProductFromCart,
  increaseProductQuantity,
  decreaseProductQuantity,
  increaseCustomComboQuantityCart,
  decreaseCustomComboQuantityCart,
  editComboFromCart,
} = commerceStore

// When in compact mode, always show actions in menu
// When expanded, show them as circular buttons
const showActions = computed(() => !props.compactView)
</script>

<template>
  <div class="rounded bg-white shadow-lg">
    <ul
      v-if="cart"
      class="m-0 list-none pl-0"
    >
      <li
        v-for="(item) in cart"
        :key="`cart-list-item${item.cart_uuid}`"
        class="p-2 odd:bg-blue-50"
      >
        <!-- Product Renderer -->
        <ProductItemRenderer
          v-if="item.type === 'PRODUCT'"
          :item="item"
          :show-actions="showActions"
          :compact-view="compactView"
          context="cart"
          @increase="increaseProductQuantity"
          @decrease="decreaseProductQuantity"
          @edit="editProductFromCart"
          @remove="removeProductFromCart"
        />

        <!-- Combo Renderer -->
        <ComboItemRenderer
          v-else-if="item.type === 'COMBO'"
          :item="item"
          :show-actions="showActions"
          :compact-view="compactView"
          context="cart"
          @increase="increaseCustomComboQuantityCart"
          @decrease="decreaseCustomComboQuantityCart"
          @edit="editComboFromCart"
          @remove="removeProductFromCart"
        />

        <!-- Custom Combo Renderer -->
        <CustomComboItemRenderer
          v-else-if="item.type === 'CUSTOM_COMBO'"
          :item="item"
          :show-actions="showActions"
          :compact-view="compactView"
          context="cart"
          @increase="increaseCustomComboQuantityCart"
          @decrease="decreaseCustomComboQuantityCart"
          @edit="editComboFromCart"
          @remove="removeProductFromCart"
        />
      </li>
    </ul>
  </div>
</template>

<style scoped>
.tappy-smaller-list {
  font-size: .9rem;
}

.tappy-smaller-list li {
  padding: 0.5rem 0;
  border-bottom: 1px solid #eee;
}

.tappy-smaller-list li:last-child {
  border-bottom: none;
}
</style>
